import angular from 'angular';
import scenes from './scenes';

export default angular.module('scenes.insuranceQuoteOpportunities', [scenes])
  .name;
